import styles from './ContainerLayout.module.css';
import { PostAuthFlows } from '../pages/AuthResponse';

const ContainerLayout = ({
  children,
  currentPostAuthFlow,
  enableResponsiveStyles,
}: {
  children: React.ReactNode;
  currentPostAuthFlow?: PostAuthFlows;
  enableResponsiveStyles?: boolean;
}) => {
  let classes = styles.container;
  if (enableResponsiveStyles || currentPostAuthFlow) {
    const isProfileAndPreferences =
      currentPostAuthFlow === PostAuthFlows.ProfileAndPreferences;
    classes = `${styles.responsiveContainer} ${
      isProfileAndPreferences ? styles.max : styles.default
    }`;
  }

  return <div className={classes}>{children}</div>;
};

export default ContainerLayout;
